/* eslint-disable react/prop-types */
import { h } from 'preact'
import useResource from '../../core/hooks/useResource'

export default function Logo({ logo }) {
	if (!logo.logoPath) return null

	return (
		<div className="site-logo">
			<a href={useResource('global.storeUrl')} className="md-logo">
				<img
					height="53"
					width="51"
					alt="Min Dörr Osby AB"
					src="https://www.mindorr.se/images/thumbs/0000001_logo.png"
					style="aspect-ratio: 42 / 43;"
				/>
			</a>

			<a href="/" className="store-logo">
				<img
					height={logo.height || 40}
					alt={logo.storeName}
					src={logo.logoPath}
				/>
			</a>
		</div>
	)
}
